import type { CSSProperties } from 'react'

import type { EstiloDeCorte, Trama } from './estilosDeCorte'

/** Amostra da trama em CSS, para se escolher a ver. */
export function amostraDaTrama(e: EstiloDeCorte): CSSProperties {
  const t = e.corDaTrama
  const linhas = (ang: number) =>
    `repeating-linear-gradient(${ang}deg, ${t} 0 1px, transparent 1px 6px)`
  const fundo = e.fundo
  const por: Record<Trama, string> = {
    cheio: 'none',
    diagonal: linhas(-45),
    'diagonal-inversa': linhas(45),
    cruzada: `${linhas(-45)}, ${linhas(45)}`,
    horizontal: linhas(0),
    vertical: linhas(90),
    pontos: `radial-gradient(${t} 1px, transparent 1.5px)`,
    betao: `radial-gradient(${t} 0.8px, transparent 1.2px), radial-gradient(${t} 1.2px, transparent 1.6px)`,
    isolamento: `repeating-radial-gradient(circle at 0 100%, transparent 0 3px, ${t} 3px 4px, transparent 4px 7px)`,
  }
  return {
    backgroundColor: fundo,
    backgroundImage: por[e.trama],
    backgroundSize:
      e.trama === 'pontos' ? '6px 6px' : e.trama === 'betao' ? '7px 7px, 11px 11px' : e.trama === 'isolamento' ? '10px 8px' : undefined,
    backgroundPosition: e.trama === 'betao' ? '0 0, 3px 5px' : undefined,
  }
}
